import DashBoardIcon from "@/components/svg/dashboardIcon";
import {  Box, Clipboard, Folder,     Target } from "lucide-react";
import React from 'react'


export const noSideBarsMenuPages = [
  "/on-board",
  "/organization",
  "",
  "/invitation",
  "/shared-asset/[id]",
  "/subscription",
  "/payment-confirmation",
  "/payment-details",
  "/plans",
  "/assistant-ui"
];

export const INACTIVE_NOTICE_EXCLUDED_PATHS = [
  "/organization",
  "/payment-confirmation",
  "/subscription",
  "/on-board",
  "/shared-asset",
  "/invitation",
  "/password-reset",
  "/plans",
  "/payment-details",
];

export const PATHS_FOR_TRIAL_NOTIFICATION = [
  "/dashboard",
  "/campaigns",
  "/task-management",
  "/files",
  "/ai-campaigns",
  "/folder",
  "/account-settings/[name]",
  "/ai-mode",
];

export const navData = [
  {
    title: "Dashboard",
    icon: () => <DashBoardIcon stroke="#333" height={14} width={14} className="ml-1" />,
    path: "/dashboard",
    allowedRole: [1, 2, 3, 4],
    type: "link",
  },
  {
    title: "Workflows",
    icon: Target,
    path: "/campaigns",
    allowedRole: [1, 2, 3, 4],
    type: "link",
  },
  {
    title: "Task Manager",
    icon: Clipboard,
    path: "/task-management",
    allowedRole: [1, 2, 3, 4],
    type: "link",
  },

  {
    title: "Brand Assets",
    icon: Box,
    path: "/brand-management/company",
    allowedRole: [1, 2, 3],
    type: "link",
  },

  {
    title: "Files",
    icon: Folder,
    path: "/folder",
    allowedRole: [1, 2, 3, 4],
    type: "link",
  },
  // {
  //   title: "AI Assistant",
  //   icon: Bot,
  //   path: "/ai-mode",
  //   allowedRole: [1, 2, 3, 4],
  //   type: "link",
  // },
    // { title: "Components", 
    //   icon: LayersIcon, 
    //   path: "/ui-elements", 
    //   allowedRole: [1, 2, 3, 4], 
    //   type: "link" 
    // },

];
